import { DatePickerAdapter } from 'components/enhanced/form/adapters/date-time/DatePickerAdapter';
import { AutocompleteAdapter } from 'components/enhanced/form/adapters/selects/AutocompleteAdapter';
import { TextFieldAdapter } from 'components/enhanced/form/adapters/text-inputs/TextFieldAdapter';
import EnhancedForm from 'components/enhanced/form/EnhancedForm';
import { IdentityField } from 'components/enhanced/form/fields/IdentityField';
import { required } from 'components/helpers/validators';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { contractService } from 'shared/services';
import { Option } from 'shared/types/general';

interface EquipmentInvoiceCreateFormProps {
  onSubmit: any;
}
function EquipmentInvoiceCreateForm({ onSubmit }: EquipmentInvoiceCreateFormProps) {
  const { t } = useTranslation();

  const [contracts, setContracts] = useState<Option[]>([]);

  useEffect(() => {
    contractService.getAllBaseInformation().then((res) => {
      setContracts(
        res.map((contract) => {
          return {
            ...contract,
            code: `${contract.supplier} - ${contract.code}`
          };
        })
      );
    });
  }, []);

  return (
    <EnhancedForm onSubmit={onSubmit} formId="newInvoice" hideControls autoStyleLayout columns={2}>
      <IdentityField
        gridSpan={2}
        name="contract"
        component={AutocompleteAdapter}
        options={contracts}
        placeholder={t('global.contract')}
        label={t('global.contract')}
        validate={required}
        required
      />
      <IdentityField
        name="ref"
        label={t(`entities.ddt.invoice_ref`)}
        component={TextFieldAdapter}
        required
      />
      <IdentityField name="date" label={t(`global.date`)} component={DatePickerAdapter} />
    </EnhancedForm>
  );
}

export default EquipmentInvoiceCreateForm;
